import React from 'react'
import logoImg from '../../img/logo-swiftbank.svg';


function Logo(props) {
    return (
          <img {...props} src={logoImg} alt="Swift Finance Logo" aria-label="Swift Finance Logo"/>
    )
}

export default Logo
